import React, { useContext, useEffect, useState } from 'react';
import { Container, Row, Col, Button, Form, Card, Carousel, Navbar, Nav } from "react-bootstrap";
import { FaSearch, FaAngleDoubleRight, FaArrowLeft, FaHeart, FaAngleRight, FaMapMarkerAlt, FaHome, FaList } from "react-icons/fa";

import axios from 'axios';
import { site_url, site_url_img } from "./../config.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.css";
import { useLocation } from 'react-router-dom';
import { AuthContext } from './../AuthContext';
import { parseStoredAccessToken } from '../parseStoredAccessToken.js';
import { FormatDate } from '../Function';

import { Link } from "react-router-dom";

function Index() {
  const [productcategorydata, setproductcategorydata] = useState([]);
  const { user, fulluser } = useContext(AuthContext);

  const [data, setdata] = useState([]);

  const formatBonusType = (typeValue) => {
    if (!typeValue) return "";

    return String(typeValue)
      .replace(/_slug/gi, "")
      .replace(/_/g, " ")
      .split(" ")
      .filter(Boolean)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };


  const location = useLocation();

  useEffect(() => {
    // Remove modal backdrops
    const backdrops = document.querySelectorAll(".modal-backdrop");
    backdrops.forEach((el) => el.remove());

    // Remove modal-open class
    document.body.classList.remove("modal-open");

    // Remove inline styles like overflow and padding
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";

    // Optionally, clear all inline styles (use with caution)
    // document.body.removeAttribute("style");
  }, [location]);

  const goBack = () => {
    window.history.back(); // Goes back to the previous page
  };

  useEffect(() => {
    getUserdetails();
  }, [user]);

  const getUserdetails = async () => {
    const token = parseStoredAccessToken(user);
    if (token) {
      axios.get(site_url + "/yeartransactions", {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json'
        }
      })
        .then(res => {
          console.log(res.data.wallet);
          if (res.data.status == 'success') {
            setdata(Array.isArray(res.data.wallet) ? res.data.wallet : []);

          } else {

          }
        })
        .catch(err => {
          console.error("API Error:", err.response.data);
        });
    }
  };


  return (
    <div><div className="min-vh-100">
      {/* Navbar */}
      <Navbar expand="lg" className="navbar px-3">

        <Navbar.Brand className="fw-bold text-white"><center><FaArrowLeft onClick={goBack} className="fs-5 text-white notificaton-icon" />Life Time Reward Point Earned</center></Navbar.Brand>
        <Nav className="ms-auto d-flex align-items-center">
        </Nav>
      </Navbar>
      <div className="row justify-content-center mt-2 p-2">

        {(!data || data.length === 0) && (
          <div className="col-12 p-3 text-center text-muted">
            No reward points yet.
          </div>
        )}
        {data.map((shop, index) => (
          <div className="col-12 p-1" key={shop.id || index}>
            <Link  state={{ shop }}>
              <Col xs={12} key={index} className="">
                <Card >
                  <Card.Body>
                    <div className='row'>
                      <div className='col-4'>
                        <center><img src={'./star.png'} className="shoplist_img" /></center>

                      </div>
                      <div className='col-8'>
                        <h3><span className="shoplist_text">Bonus Rs.{shop.amount_rupees != null ? Number(shop.amount_rupees).toFixed(2) : (shop.amount / 100)}</span></h3>
                        <p className="shoplist_dcr">Date : {FormatDate(shop.created_at)}</p>
                        <p className="shoplist_dcr">Type : {shop.is_overflow ? 'Overflow Account' : formatBonusType(shop.slug)}{shop.bonus_type ? ` (${formatBonusType(shop.bonus_type)})` : ''}</p>
                        {shop.expires_at && (
                          <p className="shoplist_dcr">Expiry : {FormatDate(shop.expires_at)}</p>
                        )}
                        {shop.billno && (
                          <p className="shoplist_dcr">Bill : {shop.billno} - <b className="text-danger">₹{shop.totalbillamount}</b></p>
                        )}
                        {shop.notes && (
                          <p className="shoplist_dcr" style={{ color: shop.is_overflow ? '#b45309' : '#555', fontWeight: shop.is_overflow ? 600 : 400 }}>
                            Notes : {shop.notes}
                          </p>
                        )}

                      </div>
                    </div>
                  </Card.Body>

                </Card>
              </Col>
            </Link>
          </div>

        ))}
      </div>

    </div>
    </div>
  )
}
export default Index